import axios from "axios";

export const getRequest = (url, config = {}) => {
  return axios.get(url, config);
};

export const postRequest = (url, data = {}, config = {}) => {
  return axios.post(url, data, config);
};

export const putRequest = (url, data = {}, config = {}) => {
  return axios.put(url, data, config);
};

export const patchRequest = (url, data = {}, config = {}) => {
  return axios.patch(url, data, config);
};

export const deleteRequest = (url, config = {}) => {
  return axios.delete(url, config);
};

export const fetchRequest = (config = {}) => {
  return axios(config);
};